import { useEffect } from 'react';
import { auth } from '../FirebaseConfig.js';
import Loader from './Loader.js';

function ForceSignOut() {
    useEffect(() => {
        const logOut = async () => {
            await auth.signOut();
            window.location.replace('/login');
        };

        logOut();
    }, []);

    return(
        <Loader />
    )
}

export default ForceSignOut;